import { drybulkCargoOperationsService } from "@services/drybulkCargoOperationsApi";
import { useQuery } from "@tanstack/react-query";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";

/** DBCO-0059 - the Final Delay Report: read when its sub-tab is selected, and never polled, because it is frozen at Complete. */
export const useFinalDelayReport = (operationId: string, enabled: boolean) =>
  useQuery({
    queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.finalDelayReport(operationId),
    queryFn: () => drybulkCargoOperationsService.finalDelayReport(operationId),
    enabled: enabled && Boolean(operationId),
    retry: false,
    refetchOnWindowFocus: false,
  });
